import React from "react";
import { getStatusColor, STATUS_TEXT_COLORS } from "../statusColors";
import { circle } from "react-icons-kit/fa/circle";
import { Icon } from "react-icons-kit";
const TestListItem = ({ test }) => {
  if (!test) return null;

  const formatDate = (dateString) => {
    if (!dateString) return "";
    try {
      const date = new Date(dateString);
      return date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "short",
        day: "numeric",
      });
    } catch (e) {
      return dateString;
    }
  };

  const statusLineText = test.statusLine1 || test.statusLine2 || "";

  return (
    <div
      style={{
        padding: "8px 0",
        borderBottom: "1px solid #f0f0f0",
        display: "flex",
        justifyContent: "space-between",
      }}
    >
      <div style={{ fontSize: "14px", fontWeight: "600", color: "#333", marginBottom: "4px", width: "85%" }}>
        <Icon
          icon={circle}
          size={18}
          style={{ marginTop: "0px", flexShrink: 0, color: getStatusColor(test.status), marginInlineEnd: "10px" }}
        />
        {test.title}
      </div>

      <div style={{}}>
        {statusLineText && (
          <span
            style={{
              fontSize: "12px",
              color: test.status === "overdue" ? STATUS_TEXT_COLORS.overdue : "#666",
              marginBottom: "6px",
            }}
          >
            {statusLineText}
          </span>
        )}
      </div>
    </div>
  );
};

export default TestListItem;



// WEBPACK FOOTER //
// ./src/components/InspectionSchedule/components/TestListItem.jsx